import { FC } from "react";

export type TRowData = {
    child: React.ReactElement;
    width: number;
    classes?: string;
};

const TableRow: FC<TRowData>
    = ({
        child,
        width,
        classes,
    }) => {
        return (
            <div
                className={`p-3 fs-14 border-r ${classes} break-words`}
                style={{ width: `${width}%`, minWidth: `${width}%` }}
            >
                {child}
            </div>
        );
    }

export default TableRow;